
define('text!templates/modules/template/edit/calendar/calendar-component/template-calendar-week.html',[],function () { return '<td class="remove-week">\n    <button class="btn btn-md btn-danger btn-rounded" id="btn-remove-week">\n        <span class="fa fa-times"></span> <span class="remove-week-text">{{#t}}questionnaire:Remove Previous Week{{/t}}</span>\n    </button>\n</td>\n';});

